const EXPONENT_FORMAT = new Intl.NumberFormat('de-DE', { maximumSignificantDigits: 20 })

/**
 * 4.6e-14 -> 0.000000000000046
 *
 * Reverse can be achieved with: <number>.toExponential()
 */
export function formatExponentNumber(n: number): string {
  return EXPONENT_FORMAT.format(n)
}

export function roundToStep(value: number, step: number, mode: 'round' | 'ceil' | 'floor' = 'round'): number {
  if (step === 0) {
    console.error('Step must not be 0')
    return value
  }

  const factor = 1 / step

  switch (mode) {
    case 'ceil':
      return Math.ceil(value * factor) / factor
    case 'floor':
      return Math.floor(value * factor) / factor
    case 'round':
    default:
      return Math.round(value * factor) / factor
  }
}
